/**
 * Map Interaction Demo
 *
 * This module demonstrates how to use the mapCameraUtils to extract camera positions
 * and create hardcoded camera positions based on user interactions.
 */

import { getMapManager } from '../components/Map/MapManager.js';
import { getCurrentCameraPosition, saveCurrentCameraPosition } from './mapCameraUtils.js';

// Store saved camera positions
const savedPositions = {};

/**
 * Initialize the map interaction demo
 * No longer captures camera positions on click
 */
export function initMapInteractionDemo() {
    const mapManager = getMapManager();
    if (!mapManager || !mapManager.getMap()) {
        console.error('[MapInteractionDemo] Map not initialized');
        return;
    }
    
    console.log('[MapInteractionDemo] Initialized');
}

/**
 * Adds demo controls to the map
 */
function addDemoControls(map) {
    // Create a custom control container
    const controlContainer = document.createElement('div');
    controlContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    controlContainer.style.margin = '10px';
    
    // Create a button to log the current position
    const logButton = document.createElement('button');
    logButton.type = 'button';
    logButton.className = 'mapboxgl-ctrl-icon';
    logButton.innerHTML = '<span style="font-size: 18px;">📷</span>';
    logButton.title = 'Log Current Camera Position';
    logButton.onclick = () => {
        const position = getCurrentCameraPosition();
        console.log('[MapInteractionDemo] Current camera position:', position);
        
        // Format position for console logging
        const positionText = `
// Hardcoded camera position
const cameraPosition = {
    center: [${position.center[0].toFixed(6)}, ${position.center[1].toFixed(6)}],
    zoom: ${position.zoom.toFixed(2)},
    pitch: ${position.pitch.toFixed(2)},
    bearing: ${position.bearing.toFixed(2)}
};
`;
        // Log to console instead of trying to copy to clipboard
        console.log('[MapInteractionDemo] Current camera position:');
        console.log(positionText);
        
        // Show message to user
        showPositionSavedMessage(position);
    };
    
    // Add the button to the container
    controlContainer.appendChild(logButton);
    
    // Add the control to the map
    map.addControl({
        onAdd: function() {
            return controlContainer;
        },
        onRemove: function() {
            controlContainer.parentNode.removeChild(controlContainer);
        }
    });
}

/**
 * Example of creating a dynamic camera position function
 * This can be used directly in your code
 */
export function goToMadinahOverview() {
    // Get Madinah coordinates from DOM
    const madinahPanel = document.querySelector('.panel[data-city-id="madinah"]');
    if (!madinahPanel) {
        console.error('[MapInteractionDemo] Madinah panel not found');
        return;
    }
    
    const lat = parseFloat(madinahPanel.dataset.lat);
    const lng = parseFloat(madinahPanel.dataset.lng);
    
    if (isNaN(lat) || isNaN(lng)) {
        console.error('[MapInteractionDemo] Invalid Madinah coordinates');
        return;
    }
    
    // Dynamic camera position for Madinah overview
    const cameraPosition = {
        center: [lng, lat],
        zoom: 12.5,
        pitch: 60,
        bearing: 15
    };
    
    // Use the saveCurrentCameraPosition function to create a transition function
    const transitionFunction = saveCurrentCameraPosition('madinah-overview');
    
    // Execute the transition
    return transitionFunction({ duration: 2500 });
}